<template>
    <theme-provider :theme="theme">
        <router-view />
    </theme-provider>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'App',
    computed: {
        ...mapState({
            appSetting: state => state.modeling.appSetting,
        }),
        theme() {
            return {
                global: this.appSetting?.global,
                component: this.appSetting?.component,
            }
        },
    },
}
</script>
